import React from "react";
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
import Dialog from '../elements/Dialog';

//import * as videoTypes from '../../constants/videoTypes';

export default class VideoOverlay extends React.PureComponent {
    state = {
        isShown: false,
    };
    static getDerivedStateFromProps(props, state) {
        if (!state.isShown && props.playingVideoLink !== '') {
            document.body.style.overflow = "hidden";
            return {...state, isShown: true};
        }
        if (state.isShown && props.playingVideoLink === '') {
            document.body.style.overflow = "";
            return {...state, isShown: false};
        }
        return null;
    }
    componentDidMount() {
        document.addEventListener("keydown", this.keyDownHandler);
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.keyDownHandler);
    }
    keyDownHandler = (e) => {
        let { isShown } = this.state;

        if (!isShown) {
            return false;
        }

        if (e.keyCode === 27) {
            this.videoStopHandler();
        }
    };
    videoStopHandler = () => {
        let { stopVideo } = this.props;

        stopVideo();
    };
    renderVideo = () => {
        let { playingVideoLink, playingVideoType } = this.props;

        const videoClass = 'video-overlay';

        switch (playingVideoType) {
            default:
                return <YouTube
                    opts={{
                        width: false,
                        height: false,
                        playerVars: {
                            autoplay: 1,
                        }
                    }}

                    videoId={playingVideoLink}
                    className={`${videoClass} video-overlay youtube`}
                    onReady={this.videoLoadHandler}
                    autoplay={true}
                />;
        }
    };
    render() {
        let { playingVideoLink } = this.props;

        if (playingVideoLink === '') {
            return false;
        }

        return (
            <Dialog className={'video-dialog'} onClose={this.videoStopHandler} isVisible={true}>
                <button onClick={this.videoStopHandler} className={'closer'}>×</button>
                <div>
                    {this.renderVideo()}
                </div>
            </Dialog>
        )
    }
}

VideoOverlay.propTypes = {
    playingVideoLink: PropTypes.string.isRequired,
    playingVideoType: PropTypes.string.isRequired,
    stopVideo: PropTypes.func.isRequired,
};
